export default __webpack_public_path__ + "static/media/Pia_9781408308172.91dde1f4.jpg";